// Restore event from deleted section
export const restoreEvent = (state, action) => {
  const eventKey = action.payload;
  const event = state.events.find((e) => e.key === eventKey);
  if (event) {
    event.isDeleted = false;
  }
};

// Permanently delete event
export const permanentDeleteEvent = (state, action) => {
  const eventKey = action.payload;
  state.events = state.events.filter((e) => e.key !== eventKey);
};

// Fetch Events Reducers
export const eventsRequested = (state) => {
  state.status = "loading";
};

export const eventsReceived = (state, action) => {
  state.status = "succeeded";
  // Store raw data, let the component handle mapping
  if (Array.isArray(action.payload)) {
    state.events = action.payload;
  } else {
    // Handle wrapped response, e.g. { data: [...] } or { events: [...] }
    state.events = action.payload.data || action.payload.events || [];
  }
};

export const eventsRequestFailed = (state, action) => {
  state.status = "failed";
  state.error = action.payload;
};